import { useQueryClient } from "@tanstack/react-query";
import React from "react";
import { Link } from "react-router-dom";
import { updateTapCount } from "../../../helpers/tapCountMutation";
// import {websiteIcon } from "../Common/SvgIcon";

function GridWebsite({ website, preview, Textcolor, BtIColor }) {
  const websiteIcon = (
    <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.3125"
        y="0.8125"
        width="29.375"
        height="29.375"
        rx="14.6875"
        stroke={BtIColor ? BtIColor : "black"}
        strokeWidth="0.625"
      />
      <path
        d="M10.0893 18.3348C9.49081 17.2982 9.84696 15.9691 10.8836 15.3706L13.3085 13.9706L12.6435 12.8188L10.2186 14.2188C8.54543 15.1848 7.9715 17.3267 8.9375 18.9998C9.9035 20.673 12.0454 21.2469 13.7186 20.2809L16.1435 18.8809L15.4785 17.7291L13.0536 19.1291C12.017 19.7276 10.6878 19.3715 10.0893 18.3348ZM12.9248 17.5061L17.7745 14.7061L17.0745 13.4936L12.2248 16.2936L12.9248 17.5061ZM16.2808 10.7188L13.8559 12.1188L14.5209 13.2706L16.9458 11.8706C17.9824 11.2721 19.3115 11.6282 19.91 12.6648C20.5085 13.7015 20.1524 15.0306 19.1158 15.6291L16.6909 17.0291L17.3559 18.1809L19.7808 16.7809C21.4539 15.8149 22.0279 13.673 21.0619 11.9998C20.0959 10.3267 17.9539 9.75275 16.2808 10.7188Z"
        fill={BtIColor ? BtIColor : "black"}
      />
    </svg>


  );

  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button, id) => {
    // console.log("iiii", id);

    updateTapCount(queryClient, button, id);
  };


  return (
    <div className="grid grid-cols-2 items-center  p-2">
      {website.map((websiteDetails, index) => {
        return websiteDetails?.websiteName ? (
          <Link
            key={index}
            onClick={() => handleTap('website', websiteDetails._id)}
            to={`${preview ? websiteDetails?.websiteUrl : ""}`}
            target={`${preview ? "_blank" : ""}`}
          >
            <div className="max-w-[197px] h-[139px] border-[#F2F2F2] border rounded-[8px] items-center p-8">
              <div className="flex items-center justify-center h-[54px]">
                {websiteIcon}
              </div>

              <p className="text-[12px] text-black  text-center" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
                {websiteDetails.websiteName}
              </p>
            </div>
          </Link>
        ) : (
          ""
        );
      })}
    </div>
  );
}

export default GridWebsite;
